import { render, staticRenderFns } from "./ManageUserGroups.vue?vue&type=template&id=115b34ea&scoped=true"
import script from "./ManageUserGroups.vue?vue&type=script&lang=js"
export * from "./ManageUserGroups.vue?vue&type=script&lang=js"
import style0 from "./ManageUserGroups.vue?vue&type=style&index=0&id=115b34ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b34ea",
  null
  
)

export default component.exports